import { render, staticRenderFns } from "./ku-forum-layout.vue?vue&type=template&id=34c88403&scoped=true"
import script from "./ku-forum-layout.vue?vue&type=script&lang=js"
export * from "./ku-forum-layout.vue?vue&type=script&lang=js"
import style0 from "./ku-forum-layout.vue?vue&type=style&index=0&id=34c88403&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c88403",
  null
  
)

export default component.exports